import styled from 'styled-components';

import transparentBackground from '../../../static/transparent-background.svg';
import style from '../../style';

interface PaletteProps {
  $isSelected: boolean;
}

interface ColorProps {
  $color: string;
  $thereAreMultipleColors: boolean;
}

export const Palette = styled.div<PaletteProps>(
  ({ theme: { size, color, transition }, $isSelected }) => ({
    display: 'flex',
    cursor: 'pointer',
    width: '100%',
    height: '100%',
    position: 'relative',
    borderRadius: size.units(0.5),

    ':before': {
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      content: '""',
      position: 'absolute',
      borderRadius: size.units(0.5),
      backgroundImage: `url("${transparentBackground}")`,
      zIndex: -1,
    },

    ':after': {
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      content: '""',
      position: 'absolute',
      borderRadius: size.units(0.5),
      boxShadow: $isSelected
        ? `0px 0px 0px 2px ${color.shadow.accent.default()}, inset 0px 0px 0px 1px ${color.shadow.reversed.default()}`
        : `0px 0px 0px 2px transparent, inset 0px 0px 0px 1px ${color.shadow.primary.default(
            0.2,
          )}`,
      transition: transition.standard('box-shadow'),
      zIndex: 1,
    },

    ...(!$isSelected
      ? style.mixins.devices.desktop({
          ':hover:after': {
            boxShadow: `0px 0px 0px 2px transparent, inset 0px 0px 0px 2px ${color.shadow.primary.default(
              0.5,
            )}`,
          },

          ':active:after': {
            transition: 'box-shadow 0.1s cubic-bezier(0.4, 0, 0.4, 1)',
            boxShadow: `0px 0px 0px 2px transparent, inset 0px 0px 0px 1px ${color.shadow.primary.default(
              0,
            )}`,
          },
        })
      : {}),
  }),
);

export const Color = styled.div<ColorProps>(
  ({ theme: { size }, $color, $thereAreMultipleColors }) => ({
    flex: '1 1 0px',
    backgroundColor: $color || 'rgb(255, 255, 255)',

    ...($thereAreMultipleColors
      ? {
          ':first-child': {
            borderRadius: `${size.units(0.5)} 0 0 ${size.units(0.5)}`,
          },

          ':last-child': {
            borderRadius: `0 ${size.units(0.5)} ${size.units(0.5)} 0`,
          },
        }
      : {
          borderRadius: size.units(0.5),
        }),
  }),
);
